module.exports = __webpack_public_path__ + "media/kingofkpop-premium.fa1e5c8a.mp4";